import React from 'react';

import useStoreState from '../stores/useStoreState';
import FeatureFlagStore from '../stores/FeatureFlagStore';
import debugHook from './hookUtils';

export default debugHook(useFeatureFlag, 'useFeatureFlag');

/**
 * Hook to retrieve value (or values) of feature flags
 *
 * If you ask for a single flag, it will return the value
 * If you ask for an array of flags, it will return an object populated with the values of the flags
 * If you pass a function, it will return the value from the function (passed the FeatureFlagStore)
 *
 * @param {String|String[]|Function} - Which flag or flags to fetch
 */
export function useFeatureFlag(flag) {
    const lookup = React.useMemo(() => {
        if (Array.isArray(flag)) {
            // connect to store, and populate an object with the values of all the flags
            return store => {
                let values = {};
                flag.forEach(f => {
                    values[f] = store.get(f);
                });
                return values;
            };
        } else {
            // pass the stateLookup directly to useStoreState
            return flag;
        }
    }, [flag]);
    return useStoreState(FeatureFlagStore, lookup);
}



// WEBPACK FOOTER //
// ./src/hooks/useFeatureFlag.js